import createDebug from 'debug'

export default createDebug('sanity:migrate')
